import type { OfferPreset } from "../../types"

import hero from "@/features/offers/assets/astromap/hero.webp"
import feature1 from "@/features/offers/assets/astromap/feature-1.svg"
import feature2 from "@/features/offers/assets/astromap/feature-2.svg"
import feature3 from "@/features/offers/assets/astromap/feature-3.svg"
import gift from "@/features/offers/assets/astromap/gift.webp"
import card1 from "@/features/offers/assets/astromap/card-1.webp"
import card2 from "@/features/offers/assets/astromap/card-2.webp"
import chipBirthBased from "@/features/offers/assets/astromap/chip-birthbased.svg"
import chipAstroLines from "@/features/offers/assets/astromap/chip-astrolines.svg"
import reviewer7 from "@/features/offers/assets/astromap/reviewer-7.webp"
import reviewer8 from "@/features/offers/assets/astromap/reviewer-8.webp"
import reviewer9 from "@/features/offers/assets/astromap/reviewer-9.webp"

export const astromapPreset: OfferPreset = {
  key: "astromap",
  stepLabel: "Map",
  unlockedLabel: "Exclusive Astro Map unlocked",
  hero: {
    title: "Discover Where You Thrive",
    subtitle:
      "Reveal the places and planetary lines where your love life, career growth, money potential, and sense of purpose may align strongest",
    bg: hero,
    fullBleed: false,
  },
  benefits: [
    {
      icon: feature1,
      title: "Decode planetary lines",
      subtitle: "See what each line means and how different planets may influence your path",
    },
    {
      icon: feature2,
      title: "Find Your Strongest Locations",
      subtitle: "Explore cities and regions where your energy may feel more supported",
    },
    {
      icon: feature3,
      title: "Discover Life Area Hotspots",
      subtitle: "Find which zones are linked to love, money, wellbeing, or major life changes",
    },
  ],
  gift: {
    title: "Planetary Lines Preview",
    subtitle: "Unlock a first look at the most important lines on your personal map",
    image: gift,
    strikePrice: "$19.99",
    fillImage: true,
  },
  price: {
    heading: "Your Astro Map Awaits",
    reportLabel: "Astro Map Report",
    giftLabel: "Planetary Lines Preview",
  },
  ctaLabel: "Unlock Astro Map",
  featureCards: {
    heading: "Why Your Astro Map Feels Personal & Clear",
    cards: [
      {
        image: card1,
        title: "Built From Your Birth Profile",
        subtitle:
          "Your map uses the birth details you provide to place planetary lines across the world and shape your personal astrocartography view",
        chips: [
          { icon: chipBirthBased, label: "Birth-Based" },
          { icon: chipAstroLines, label: "Astro Lines" },
        ],
      },
      {
        image: card2,
        title: "Planetary Lines Explained",
        subtitle:
          "Each line comes with a clear meaning, helping you understand what different places may represent for growth, change, or opportunity",
        chips: [],
      },
    ],
  },
  reviews: {
    heading: "What users say after unlocking their map",
    items: [
      {
        avatar: reviewer7,
        name: "Mia Parker",
        rating: "4.9",
        text: "I didn’t expect the map to feel so personal. Seeing the lines placed across real locations made the whole reading easier to understand.",
      },
      {
        avatar: reviewer8,
        name: "Ethan Cole",
        rating: "5.0",
        text: "The planetary lines helped me look at places in a completely new way. It felt less abstract than a normal astrology report.",
      },
      {
        avatar: reviewer9,
        name: "Rachel Morgan",
        rating: "4.8",
        text: "I liked that the map gave structure to the reading. It connected my birth profile with locations, timing, and the idea of where I may feel more aligned.",
      },
    ],
  },
}
